import * as Sentry from "@sentry/vue";

if (
    window.env
    && window.env.SENTRY_LARAVEL_DSN !== null
    && window.env.SENTRY_LARAVEL_DSN !== 'null'
) {
    const beforeSend: Sentry.BrowserOptions['beforeSend'] = (event) => {
        const message = event.exception?.values?.[0]?.value ?? '';
        if (message.includes('Failed to fetch') || message.includes('Load failed') || message.includes('Network Error') || message.includes('NetworkError when attempting to fetch resource') || message.includes("Can't find variable: _AutofillCallbackHandler")) {
            return null;
        }

        const frames = event.exception?.values?.[0]?.stacktrace?.frames ?? [];
        if (frames.some(frame => frame.filename?.includes('conf2'))) {
            return null;
        }

        return event;
    };

    Sentry.init({
        dsn: window.env.SENTRY_LARAVEL_DSN,
        attachProps: true,
        tracesSampleRate: 0.001,
        integrations: (defaultIntegrations) => [
            ...defaultIntegrations.filter((integration) => integration.name !== 'Vue'),
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        replaysSessionSampleRate: 0.05,
        replaysOnErrorSampleRate: 0.5,
        ignoreErrors: [
            'Java object is gone',
            /webkit\.messageHandlers/,
            /Failed to read the '(session|local)Storage' property/,
            'The operation is insecure',
            'ResizeObserver loop',
            /Event `(XMLHttpRequest)?ProgressEvent` \(type=(error|abort)\) captured as promise rejection/,
            'Request aborted',
            'The operation was aborted',
            'Object Not Found Matching Id',
            'reCAPTCHA Timeout',
            /fbq is not defined|Can't find variable: fbq/,
            'Invalid call to runtime.sendMessage(). Tab not found.',
            'Blocked a frame with origin',
            /^La$/,
            'uncaught exception: undefined',
            'No identifiers allowed directly after numeric literal',
            'Can not load shelf shadow texture',
        ],
        denyUrls: [
            /^(chrome|moz|safari|safari-web)-extension:\/\//,
            /^chrome:\/\//,
            /\/s0x9\//,
            /googletagmanager\.com/,
            /connect\.facebook\.net/,
            /recaptcha/,
            /\/ekr\/snippet\.js/,
            /\/next\/embed\.js/,
            /\/2\/zp\.js/,
        ],
        beforeSend,
    });
}
